<template>
  <div class="wrapper">
    <Tabs v-model="current">
      <TabPane label="空置" name="tab1"></TabPane>
      <TabPane label="解约" name="tab2"></TabPane>
    </Tabs>
    <div class="charts-wrapper">
      <div class="unoccupied-wrapper" v-if="current==='tab1'">
        <section class="part1 flex" style="justify-content: center;padding-top: 70px;">
          <div style="width: 95%;">
            <!--<div class="mb16">空置天数</div>-->
            <ul style="font-size: 14px;">
              <li >
                <span class="vname">空置天数</span>
                <span class="vvalue">占比</span>
                <span class="vvalue">数量</span>
              </li>
              <li v-for="(item,index) in vacancyValue" :key="'keyA'+index">
                <span class="vname">{{item.name}}</span><span :class="['vvalue','color'+index]">{{(item.value*100).toFixed(2)+'%'}}</span><span :class="['vvalue','color'+index]">{{item.quantity}}</span>
              </li>
            </ul>
          </div>
        </section>
        <section class="part2">
          <div class="charts-wrapper1">
            <div id="charts1" :style="{width:chartsWidth1+'px',height:chartHeight1+'px'}"></div>
          </div>
        </section>
      </div>
      <div class="charts-wrapper2" v-if="current==='tab2'">
        <div id="charts2" :style="{width:chartsWidth2+'px',height:chartHeight2+'px'}"></div>
      </div>
    </div>
  </div>
</template>

<script>
  let echarts = require('echarts/lib/echarts')
  require('echarts/lib/chart/pie')
  require("echarts/lib/component/legend");
  require("echarts/lib/component/tooltip");
  require('echarts/theme/macarons');
  export default {
    name: "UnoccupiedAndRealesae",
    mounted() {
      this.setWH()
    },
    props: {
      vacancyValue: {
        type: Array,
        default: () => {
          return []
        }
      },
      statusValue: {
        type: Array,
        default: () => {
          return []
        }
      },
      surrenderData: {
        type: Array,
        default: () => {
          return []
        }
      },
      surrenderRate:{
        type:Object,
        default:null
      }
    },
    data() {
      return {
        current: 'tab1',
        chartsWidth1: 0,
        chartHeight1: 0,
        chartsWidth2: 0,
        chartHeight2: 0,
        chartHeight3: 0,
        chartsWidth3: 0,

      }
    },
    computed: {
      surrenderDataMap() {
        let ret = {}
        this.surrenderData.forEach(ele => {
          ret[ele.name + ''] = ele
        })
        return ret
      },


    },
    watch: {
      statusValue() {
        if (this.current === 'tab1') {
          this.setE1()
        }
      },
      surrenderData() {
        if (this.current === 'tab2') {
          this.setE2()
        }
      },

      current(value) {
        this.$nextTick(() => {
          this.setWH()
          if (value === 'tab1') {
            this.$nextTick(() => {
              this.setE1()
            })
          }
          else {
            this.$nextTick(() => {
              this.setE2()
            })
          }
        })
      }
    },
    methods: {
      //解约率图表
      setE2() {
        if (this.surrenderData.length === 0) {
          return
        }
        let e2 = echarts.init(document.getElementById('charts2'),'macarons');
        let surrenderDataMap = {}
        this.surrenderData.forEach(ele => {
          surrenderDataMap[ele.name + ''] = ele
        })

        let formatter=this.surrenderRate?(this.surrenderRate.value*100).toFixed(2)+'%':'无'

        let option = {
          title : {
            text: '解约率'+formatter,
            x:'23%',
            bottom:20
          },
          tooltip: {
            trigger: 'item',
            formatter:'{b}:{d}%'
          },
          legend: {
            selectedMode:false,
            show: true,
            orient: 'vertical',
            right: 30,
            top: 50,
            formatter: function (name) {
              return name + ' | ' + (Number(surrenderDataMap[name + ''].value * 100).toFixed(2) + '%') + '    ' + surrenderDataMap[name].quantity
              // return
            }
          },
          series: [
            {
              center: ['30%', '45%'],
              legendHoverLink:false,
              hoverAnimation:false,
              name: '',
              type: 'pie',
              radius: ['40%', '60%'],
              data: this.surrenderData,
              avoidLabelOverlap: false,
              labelLine: {
                normal: {
                  show: false
                }
              },
              label: {
                normal: {
                  show: false,
                  position: 'center'
                },
                emphasis: {
                  show: true,
                  textStyle: {
                    fontSize: '40',
                    fontWeight: 'bold'
                  },
                  formatter:function (value) {
                    return surrenderDataMap[value.name].quantity

                  }
                }
              },


            }
          ]

        }
        e2.clear()
        e2.setOption(option)
      },
      //空置率图表
      setE1() {
        if (this.statusValue.length === 0) {
          return
        }
        let e1 = echarts.init(document.getElementById('charts1'),'macarons');
        let statusValueMap = {}
        this.statusValue.forEach(ele => {
          statusValueMap[ele.name + ''] = ele
        })
        let option = {

          tooltip: {
            trigger: 'item',
            formatter: function (params) {
              return params.name+':'+(statusValueMap[params.name+''].rate*100).toFixed(2)+'%'+'('+params.value+')'
            }
          },
          series: [
            {
              legendHoverLink:false,
              hoverAnimation:false,
              name: '',
              type: 'pie',
              radius: ['35%', '55%'],
              // avoidLabelOverlap: false,
              label: {
                show: true,
                formatter:'{b}:{c}',
                fontSize: 14
                // formatter: function (params) {
                //   return params.name +':'+statusValueMap[params.name+''].quantity
                // }
              },
              labelLine: {
                show:false
              },
              data: this.statusValue
            }
          ]
        }
        e1.clear()
        e1.setOption(option)
      },
      setWH() {
        let w1 = document.getElementsByClassName('charts-wrapper1')
        if (w1.length > 0) {
          let h1 = w1[0]
          this.chartHeight1 = Number(window.getComputedStyle(h1).height.slice(0, -2))
          this.chartsWidth1 = Number(window.getComputedStyle(h1).width.slice(0, -2))
        }
        let w2 = document.getElementsByClassName('charts-wrapper2')
        if (w2.length > 0) {
          let h2 = w2[0]
          this.chartHeight2 = Number(window.getComputedStyle(h2).height.slice(0, -2))
          this.chartsWidth2 = Number(window.getComputedStyle(h2).width.slice(0, -2))
        }
        let w3 = document.getElementsByClassName('charts-wrapper3')
        if (w3.length > 0) {
          let h3 = w3[0]
          this.chartHeight3 = Number(window.getComputedStyle(h3).height.slice(0, -2))
          this.chartsWidth3 = Number(window.getComputedStyle(h3).width.slice(0, -2))
        }
      },
    }
  }
</script>

<style scoped>
  .color0{
    background-color: rgb(189,226,184);
  }
  .color1{
    background-color: rgb(168,217,161);

  }
  .color2{
    background-color: rgb(143,201,135);
  }
  .color3{
    background-color: rgb(17,152,105);
  }
  .part1 li {
    margin-top: -1px;
    display: flex;
  }

  .vname, .vvalue {
    flex: 1;
    display: inline-block;
    /*width: 90px;*/
    border: 1px solid lightgray;
    height: 40px;
    text-align: center;
    line-height: 40px;
  }

  .vvalue {
    margin-left: -1px;
  }

  .part1 {
    flex: 0.35;
    /*background-color: lightsteelblue;*/
  }

  .part2 {
    flex: .65;
    /*background-color: lightcyan;*/
  }

  .unoccupied-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
  }

  .wrapper {
    width: 100%;
    height: 100%;
    /*background-color: lightpink;*/
  }

  .charts-wrapper, .charts-wrapper2, .charts-wrapper1, .charts-wrapper3 {
    width: 100%;
    /*height: 100%;*/
    height: 350px;
    /*background-color: #cccccc;*/
    /*background-color: lightpink;*/
  }


</style>
